
import router from "@/router";
import { defineComponent, ref } from "vue";
import { User } from "@element-plus/icons-vue";
import { getauditList, listSimple, brandlist, auditInfo, auditInsrt, batchAuditInsert } from "@/api/Commodityallocation";
import { ElMessage } from "element-plus";
import moment from "moment";
import { log } from "console";
export default defineComponent({
  name: "examine",
  setup() {
    // 头部查询
    const tableloading = ref(true);
    const selectData = ref<any>({
      applyStatus: "",
      branNo: "",
      // brandNo: "",
      code: "",
      creTime: "",
      feiLei: "",
      firstGoodTypeId: "",
      pageNum: 1,
      pageSize: 5,
      prod: "",
      threeGoodTypeId: "",
      title: "",
      twoGoodTypeId: "",
    });
    // 表格数据
    const tableData = ref();
    const tableColumn = ref([
      {
        slotName: "selection",
      },
      {
        prop: "title",
        label: "商品标题",
      },
      {
        prop: "indexTitle",
        label: "商品副标题",
      },

      {
        slotName: "specifications",
      },
      {
        prop: "typeName",
        label: "所属分类",
      },
      {
        prop: "code",
        label: "商品货号",
      },
      {
        slotName: "examine",
      },

      {
        slotName: "slotName",
      },
    ]);

    // 查看规格
    const tableData2 = ref();
    const tableColumn2 = ref([
      {
        prop: "sku",
        label: "规格",
      },
      {
        prop: "price",
        label: "销售价",
      },
      {
        prop: "officialPrice",
        label: "官方价",
      },
    ]);
    // 审核详情表格
    const tableData3 = ref();
    const tableColumn3 = ref([
      {
        prop: "userNo",
        label: "审核人员",
      },
      {
        prop: "createTime",
        label: "审核时间",
      },
      {
        slotName: "result",
      },
      {
        prop: "auditInfo",
        label: "反馈详情",
      },
    ]);
    // 查看规格分页
    const guigeCurrent = ref(1);
    const pageSize = ref(5);
    const handleCurrentChange = (val: any) => {
      guigeCurrent.value = val;
    };
    // 商品品牌下拉
    const brandlistData = ref<any>();
    // 三级下拉类别
    const listSimpleArr1 = ref<any>();
    const listSimpleArr2 = ref<any>();
    const listSimpleArr3 = ref<any>();
    const state = ref<any>({
      formList: [
        // {
        //   label: "商品标题",
        //   key: "title",
        //   type: "input",
        //   placeholder: "请输入商品标题",
        //   clearable: true,
        // },
        // {
        //   label: "商品品牌",
        //   key: "branNo",
        //   type: "select",
        //   placeholder: "请选择商品品牌",
        //   clearable: true,
        //   optionList: brandlistData.value,
        // },
        // {
        //   label: "商品货号",
        //   key: "code",
        //   type: "input",
        //   placeholder: "请输入商品名称",
        //   clearable: true,
        // },
        {
          slotName: "title",
        },
        {
          slotName: "branNo",
        },
        {
          slotName: "code",
        },
        {
          slotName: "selectThree",
        },
        {
          slotName: "applyStatus",
        },
        // {
        //   label: "审核状态",
        //   key: "applyStatus",
        //   type: "select",
        //   placeholder: "请选择审核状态",
        //   clearable: true,
        //   optionList: [
        //     {
        //       label: "待审核",
        //       value: "0",
        //     },
        //     {
        //       label: "审核通过",
        //       value: "1",
        //     },
        //     {
        //       label: "审核不通过",
        //       value: "2",
        //     },
        //   ],
        // },
      ],
    });
    // select点击
    const changeSelect = (val: any, key?: any) => {
      console.log(key + "+++++++++++++++++++++++++++++");
      console.log(val, "/////////////");
      if (val == "branNo") {
        return;
      }
      if (val == "applyStatus") {
        return;
      }
      if (key == 1 && val == "") {
        listSimpleArr2.value = [];
        listSimpleArr3.value = [];
        selectData.value.twoGoodTypeId = "";
        selectData.value.threeGoodTypeId = "";
      } else if (key == 2 && val == "") {
        listSimpleArr3.value = [];
        selectData.value.threeGoodTypeId = "";
      } else {
        if (key == 1) {
          selectData.value.twoGoodTypeId = "";
          selectData.value.threeGoodTypeId = "";
        } else if (key == 2) {
          selectData.value.threeGoodTypeId = "";
        }
        listSimpleForm.value.parentId = val;
        getMyClass(key);
      }

      // listSimpleForm.value.merchantId = val.merchantId;
    };
    // 分类下拉参数
    const listSimpleForm = ref<Req.listSimple>({
      parentId: 0,
      merchantId: 0,
    });
    // 联动分类
    const getMyClass = (key?: any) => {
      // 获取一级下拉
      listSimple(listSimpleForm.value).then((res) => {
        // 第一级获得二级
        if (key == 1) {
          listSimpleArr2.value = res.data;
          // 点二级获得三级
        } else if (key == 2) {
          listSimpleArr3.value = res.data;
        } else if (key == 3) {
          return;
        } else {
          listSimpleArr1.value = res.data;
        }
      });
    };
    const Getclass = (arr: any, arr2: Res.listSimple | Res.brandlist, name?: string) => {
      arr.forEach((item: any) => {
        if (item.key == name) {
          item.optionList = arr2;
        }
      });
    };
    getMyClass();
    // 查询回显
    const getback = () => {
      if (sessionStorage.getItem("selectData")) {
        console.log(2);
        let data = JSON.parse(sessionStorage.getItem("selectData") as string);
        selectData.value.applyStatus = data.applyStatus;
        selectData.value.title = data.title;
        selectData.value.branNo = data.branNo;
        selectData.value.code = data.code;
        selectData.value.firstGoodTypeId = data.firstGoodTypeId;
        selectData.value.twoGoodTypeId = data.twoGoodTypeId;
        selectData.value.threeGoodTypeId = data.threeGoodTypeId;
        selectData.value.pageNum = data.pageNum;
        if (selectData.value.threeGoodTypeId) {
          listSimpleForm.value.parentId = data.twoGoodTypeId;
          listSimple(listSimpleForm.value).then((res) => {
            // 第一级获得二级
            listSimpleArr3.value = res.data;
          });
        }
        if (selectData.value.twoGoodTypeId) {
          listSimpleForm.value.parentId = data.firstGoodTypeId;
          listSimple(listSimpleForm.value).then((res) => {
            // 第一级获得二级
            listSimpleArr2.value = res.data;
          });
        }
      }
    };
    getback();
    const submitForm = (val: any) => {
      // selectData.value.firstGoodTypeId = val.value.typeId;
      // selectData.value.twoGoodTypeId = val.value.twoGoodTypeId;
      // selectData.value.threeGoodTypeId = val.value.threeGoodTypeId;
      // selectData.value.startTime = val.value.startTime;
      // selectData.value.name = val.value.name;
      // selectData.value.code = val.value.code;
      // selectData.value.title = val.value.title;
      // selectData.value.branNo = val.value.branNo;
      // selectData.value.applyStatus = val.value.applyStatus;
      // console.log(selectData.value);
      sessionStorage.setItem("selectData", JSON.stringify(selectData.value));
      console.log(val.value);
      getTableData();
    };

    // 获取品牌下拉
    const getbrandlist = () => {
      brandlist({ baseDto: { pageNum: 1, pageSize: 999999 } }).then((res) => {
        brandlistData.value = res.data.data;
        // console.log(brandlistData.value)
        Getclass(state.value.formList, brandlistData.value, "branNo");
      });
    };
    getbrandlist();
    const PageSizeTable = ref();
    const CurrPageTable = ref(1);
    const TotalPageTable = ref();
    const handleCurrentChangeTable = (val: any) => {
      selectData.value.pageNum = val;
      sessionStorage.setItem("selectData", JSON.stringify(selectData.value));
      getTableData();
    };
    const getTableData = () => {
      console.log(selectData.value);

      getauditList(selectData.value).then((res) => {
        console.log(res);
        tableData.value = res.data.list;
        TotalPageTable.value = res.data.total;
        tableloading.value = false;
      });
    };
    getTableData();

    // 选中打开批量审核
    // const handleSelect = (val: any, select: any) => {
    //   console.log(val, "0");
    //   // console.log(select);
    // };
    const isButtonFlag = ref<boolean>(true);
    const BatchauditData = ref<any>();
    const BatchauditDataDisplay = ref<boolean>(false);
    const BatchauditForm = ref<any>({
      auditInfo: "",
      codes: [],
      result: "0",
    });
    // 选中获取数据
    const handleSelectionChange = (val: any) => {
      console.log(val);
      if (val.length) {
        isButtonFlag.value = false;
      } else {
        isButtonFlag.value = true;
      }
      BatchauditData.value = val;
    };
    const handleSelectAll = (val: any) => {
      if (val.length) {
        isButtonFlag.value = false;
      } else {
        isButtonFlag.value = true;
      }
      BatchauditData.value = val;
    };
    const Batchaudit = () => {
      BatchauditDataDisplay.value = true;
    };
    const BatchauditProduct = () => {
      BatchauditForm.value.codes = [];
      BatchauditData.value.forEach((item: any) => {
        BatchauditForm.value.codes.push(item.code);
      });
      batchAuditInsert(BatchauditForm.value).then((res) => {
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          BatchauditDataDisplay.value = false;
          getTableData();
        }
      });
    };
    const getRowKey = (row: any) => {
      return row.typeId;
    };
    const checkSelectable = (row: any) => {
      return row.applyStatus === 0; // 判断成立则复选框能选，否则置灰禁用
    };
    // 审核详情
    const examineDetails = (row: any) => {
      console.log(row);
      tableData3.value = [];
      auditInfo(row.code).then((res) => {
        if (res.data !== null) {
          if (res.data.auditInfo == "") {
            res.data.auditInfo = "--";
          }
          tableData3.value.push(res.data);
          tableData3.value.forEach((item: any) => {
            item.createTime = moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          });
        }
      });
      auditDisplay.value = true;
    };

    // 查看规格
    const auditDisplay = ref(false);
    const pushDisplay = ref<boolean>(false);
    const seeSpecifications = (row: any) => {
      console.log(row);
      pushDisplay.value = true;
      tableData2.value = row;
      tableData2.value.map((item: any) => {
        if (!item.price) {
          item.price = "--";
        }
        if (!item.officialPrice) {
          item.officialPrice = "--";
        }
      });
    };
    // 查看详情
    const details = (row: any) => {
      // const { href } = router.resolve({
      //   path: "/Commodityallocation/stock/details",
      //   query: { code: row.code, distinguish: 1 },
      // });
      // window.open(href, "_blank");
      router.push({ path: "/Commodityallocation/stock/details", query: { code: row.code, distinguish: 1 } });
    };
    const headerimg = ref("/compontsimg/spsh.png");
    // 审核
    const auditForm = ref<any>({
      auditInfo: "",
      code: "",
      createTime: "",
      id: 0,
      merchantId: 0,
      result: "0",
      title: "",
      userNo: JSON.parse(localStorage.getItem("userInfo") as string).userName,
    });
    const auditProductDisplay = ref(false);
    const auditClick = (row: any) => {
      auditForm.value.code = row.code;
      auditForm.value.title = row.title;
      auditProductDisplay.value = true;
      console.log(auditForm.value);
      console.log(row);
    };
    const auditProduct = () => {
      auditForm.value.createTime = new Date().valueOf();
      console.log(auditForm.value);
      auditInsrt(auditForm.value).then((res) => {
        if (res.code == 1) {
          auditProductDisplay.value = false;
          ElMessage.success(res.msg as string);
          getTableData();
        } else {
          ElMessage.warning(res.msg as string);
        }
        auditProductDisplay.value = false;
      });
    };
    return {
      tableData,
      tableColumn,
      auditClick,
      listSimpleArr1,
      listSimpleArr2,
      listSimpleArr3,
      pushDisplay,
      headerimg,
      state,
      changeSelect,
      submitForm,
      User,
      tableloading,
      selectData,
      handleSelectionChange,
      handleSelectAll,
      isButtonFlag,
      examineDetails,
      seeSpecifications,
      tableData2,
      tableColumn2,
      tableData3,
      tableColumn3,
      handleCurrentChange,
      handleCurrentChangeTable,
      details,
      auditDisplay,
      auditProductDisplay,
      auditForm,
      auditProduct,
      BatchauditDataDisplay,
      Batchaudit,
      BatchauditData,
      BatchauditProduct,
      BatchauditForm,
      getRowKey,
      checkSelectable,
      guigeCurrent,
      pageSize,
      PageSizeTable,
      CurrPageTable,
      TotalPageTable,
      brandlistData,
    };
  },
});
